import { Modal, Typography, Input, Button } from "antd";
import { useState } from "react";

const { Title, Paragraph } = Typography;
const { TextArea } = Input;

const RejectionModal = ({
  open,
  title,
  content,
  buttonName,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const isReasonRequired =
    title === "Reject Application" ||
    title === "Delete" ||
    title === "Reject Discount" || 
     title === "Reject Product"
    ;

  const handleSubmit = () => {
    if (isReasonRequired && !reason.trim()) {
      setError(
        title === "Delete"
          ? "Reason for deletion is required"
          : "Reason for rejection is required"
      );
      return;
    }

    setError("");
    onSubmit(reason);
    setReason("");
    onClose();
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);

    if (e.target.value.trim()) {
      setError("");
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      className="rejection-modal"
      onCancel={onClose}
    >
      <div className="modal-content">
        <Title level={3} className="modal-title">
          {title}
        </Title>

        <Paragraph className="modal-description">
          {content}
        </Paragraph>

        {isReasonRequired && (
          <div className="input-section">
            <label className="input-label">
              {title === "Reject Application" || title === "Reject Discount" || title === "Reject Product" 
                ? "Enter your reason for Rejection (optional)"
                : "Enter your reason for Deletion (optional)"}
            </label>

            <TextArea
              rows={6}
              placeholder="Enter the reason"
              value={reason}
              status={error ? "error" : ""}
              style={{ height: "100px" }}
              onChange={handleReasonChange}
            />

            {error && (
              <div
                style={{
                  color: "#ff4d4f",
                  marginTop: 4,
                  fontSize: 12,
                }}
              >
                {error}
              </div>
            )}
          </div>
        )}

        <div className="submit-section">
          <Button
            type="primary"
            className="submit-btn"
            onClick={handleSubmit}
          >
            {buttonName}
          </Button>

          <Button
            type="primary"
            className="submit-btn"
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectionModal;